/* Aisha web store - scroll reveal + header state. Content stays visible if this script fails. */
(function () {
  var root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('am-ready');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('am-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
  );

  var SELECTOR =
    'main .shopify-section:not(:first-child), main product-card, main .product-card, footer .shopify-section';

  function scan(scope, initial) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    nodes.forEach(function (el) {
      if (el.dataset.am) return;
      el.dataset.am = '1';
      // Leave anything already on screen at page load alone (faster first paint, better LCP)
      if (initial) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) return;
      }
      // Stagger cards that sit next to each other
      if (el.matches('product-card, .product-card') && el.parentElement) {
        // Cards are usually wrapped in a list item; use that item's position in the grid
        var item = el.parentElement.matches('li') ? el.parentElement : el;
        var idx = item.parentElement ? Array.prototype.indexOf.call(item.parentElement.children, item) : 0;
        if (idx < 0) idx = 0;
        el.style.setProperty('--am-delay', (Math.min(idx % 4, 3) * 0.08).toFixed(2) + 's');
      }
      el.classList.add('am-reveal');
      io.observe(el);
    });
  }

  function start() {
    scan(document, true);
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) scan(n.parentElement || document);
          });
        });
      }).observe(main, { childList: true, subtree: true });
    }
    // Safety net: never leave content hidden
    setTimeout(function () {
      document.querySelectorAll('.am-reveal:not(.am-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('am-in');
      });
    }, 2500);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.body.classList.toggle('am-scrolled', window.scrollY > 8);
      ticking = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
